import * as React from "react";
import type { SVGProps } from "react";
const SvgPinMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pin-map_svg__a)">
      <path d="M12 18c-.3 0-.58-.13-.77-.36C10.69 17 6 11.27 6 8c0-3.53 2.47-6 6-6s6 2.47 6 6c0 3.27-4.7 9-5.23 9.64-.19.23-.47.36-.77.36m0-14C9.57 4 8 5.57 8 8c0 1.67 2.21 5.08 4 7.4 1.79-2.32 4-5.73 4-7.4 0-2.43-1.57-4-4-4" />
      <path d="M12 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
      <path d="M21 22c-.13 0-.26-.03-.39-.08l-4.11-1.73-4.11 1.73c-.25.1-.53.1-.78 0L7.5 20.19l-4.11 1.73a1.004 1.004 0 0 1-1.34-1.24l2.84-8.52c.08-.25.26-.46.5-.58l1.9-.95a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-1.53.76-2.01 6.04 2.47-1.04c.25-.1.53-.1.78 0L12 19.91l4.11-1.73c.25-.1.53-.1.78 0l2.47 1.04-2.01-6.04-1.53-.76a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.7 1.34-.45l1.9.95c.24.12.42.33.5.58l2.84 8.53a1.008 1.008 0 0 1-.95 1.32z" />
    </g>
    <defs>
      <clipPath id="pin-map_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPinMap;
